<template>
  <div>
    <div class="title">
      <div id="notice">
        <h5>车队车辆 使用说明:<br>
          <span>1、查询关键字:名称。</span><br>
        </h5>
      </div>
    </div>

    <pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
      <!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
    </pre-base>

  </div>
</template>

<script>
  export default {
    components: {
      "pre-base": () => import("../auto/auto_view_easy.vue")
    },
    data() {
      return {
        init_data: '',
        row_id: '',
        item: '',

        // 组件
        show_tan: '0',
        show_item: ''
      };
    },
    mounted: function() {
      var that = this;
      this.$nextTick(function() {
        that.fun_init();
      });
    },
    methods: {
      fun_init: function() {

        let sheet_no = '';
        this.init_data = '';
        this.init_data = JSON.stringify({
          "control": "teamcar",
          "title": "车队车辆名称",
         "isTwo": "0",
         "isTwoDetail": "0",
         "action_flag": "",
         "isFileMain": "1",
         "step": "0",
          "action_type":"short",
          "sel_action": 'exp_car_teamcarall',
          "upd_action": 'exp15_car_teamcarall',
          "file_action": '',
          "p1": '',
          "p2": '',
          "p3": '',
          "parm_sel": [
            {
              "name": "车队名称",
              "val": "",
              "key": "team_name",
              "type": "select",
              "class": "long1",
              "sel_action": "_base_teamname",
              "sel_name": "",
              "sel": "1"
            },
            {
              "name": "车辆",
              "val": "",
              "key": "team_car",
              "type": "select",
              "class": "long1",
              "sel_action": "_base_carbase",
              "sel_name": "",
              "sel": "2"
            },
            {
              "name": "状态",
              "val": "",
              "key": "flag",
              "type": "select",
              "class": "long1",
              "sel_action": "data_flag",
              "sel_name": "",
              "sel": "3"
            }
          ],
          "parm": [
            {
              "name": "车队名称",
              "val": "",
              "key": "team_name",
              "type": "select",
              "class": "long1",
              "sel_action": "_base_teamname",
              "sel_name": "",
              "p": "1"
            },
            {
              "name": "车辆",
              "val": "",
              "key": "team_car",
              "type": "select",
              "class": "long1",
              "sel_action": "_base_carbase",
              "sel_name": "",
              "p": "1"
            },
            {
              "name": "备注",
              "val": "",
              "key": "p_note",
              "type": "text",
              "class": "long2",
              "p": "1"
            }
          ],
          "parm_th": [
            {
              "name": "序号"
            },
            {
              "name": "车队名称"
            },
            {
              "name": "车牌"
            },
            {
              "name": "备注",
              "class": "long2"
            },

            {
              "name": "状态"
            },
            {
              "name": "修改人"
            },
            {
              "name": "修改时间"
            }

          ]

        });


      },
      refresh_data: function() {

        var that = this;
        this.$nextTick(function() {
          that.$refs['mybase_userApply'].refresh_data('1');
        });
      },
      refresh_father: function(type, val, parm) {
        switch (type) {
          case 'father':
            // 弹出修改明细，修改主窗口信息
            this.refresh_data();
            break;
          default:
            // console.log('子组件刷新父组件传值=' + val);
            this.row_id = val;
            this.item = parm;
            break;
        }
      }



    }
  };
</script>
<style>
</style>
